import { useState } from 'react';
import { Columns } from '@phosphor-icons/react';
import { Button } from '@/components/ui-kit/button';
import { Checkbox } from '@/components/ui-kit/checkbox';
import { Label } from '@/components/ui-kit/label';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui-kit/popover';
import { cn } from '@/lib/utils';
import type { ContactsTableColumnDef, ContactsTableColumnId } from '../../config/contacts-table-columns';

type ContactsColumnConfigDropdownProps = {
  toggleableColumns: ContactsTableColumnDef[];
  columnVisibility: Record<ContactsTableColumnId, boolean>;
  onToggleColumn: (columnId: ContactsTableColumnId, visible: boolean) => void;
  className?: string;
};

export const ContactsColumnConfigDropdown = ({
  toggleableColumns,
  columnVisibility,
  onToggleColumn,
  className,
}: ContactsColumnConfigDropdownProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className={cn('h-10 shrink-0 gap-2 px-4 text-sm font-medium', className)}
        >
          <Columns className="size-4 shrink-0" aria-hidden />
          Columns
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-56 p-4">
        <p className="mb-2 text-xs font-medium uppercase tracking-wide text-muted-foreground">
          Show columns
        </p>
        <div className="flex flex-col gap-2">
          {toggleableColumns.map((column) => (
            <div key={column.id} className="flex items-center gap-2">
              <Checkbox
                id={`contacts-column-${column.id}`}
                checked={columnVisibility[column.id]}
                onCheckedChange={(checked) => onToggleColumn(column.id, checked === true)}
              />
              <Label
                htmlFor={`contacts-column-${column.id}`}
                className="cursor-pointer text-sm font-normal"
              >
                {column.label}
              </Label>
            </div>
          ))}
        </div>
        <p className="mt-2 text-xs text-muted-foreground">Name and Email always show.</p>
      </PopoverContent>
    </Popover>
  );
};
